import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box, Container, Paper, CssBaseline, useTheme } from '@mui/material'
import { getAuthGradient } from '../../utils/themeHelpers'

export const AuthLayout: React.FC = () => {
  const theme = useTheme()
  
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: getAuthGradient(theme),
      }}
    >
      <CssBaseline />
      <Container component="main" maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 2,
          }}
        >
          <Outlet />
        </Paper>
      </Container>
    </Box>
  )
}